module.exports = __webpack_public_path__ + "images/img3.png";